(function () {

    "use strict";

    console.log("⭐ Score Card Started");

    function updateScoreCard() {

        if (!window.REVIEW_SUMMARY) {

            console.log("Waiting for REVIEW_SUMMARY...");

            setTimeout(updateScoreCard, 500);

            return;

        }

        const card = document.querySelector("#trustshop-score--card");

        if (!card) {

            console.log("Waiting for TrustShop Score Card...");

            setTimeout(updateScoreCard, 500);

            return;

        }

        const summary = window.REVIEW_SUMMARY;

        // --------------------------------------------------
        // Average Rating
        // --------------------------------------------------

        const average =
            card.querySelector(".trustshop-rating span");

        if (average) {

            average.textContent = summary.average.toFixed(1);

        }

        // --------------------------------------------------
        // Total Reviews
        // --------------------------------------------------

        // TrustShop version doesn't display total reviews here.
        // Total review count is shown by our Rating Widget.

        // --------------------------------------------------
        // Distribution Bars
        // --------------------------------------------------

        const rows =
            card.querySelectorAll(".trustshop-score-bar--item");

        rows.forEach(function (row) {

            const value =
                row.getAttribute("value");

            if (!value) return;

            const star =
                parseInt(value, 10);

            const count =
                summary.distribution[star] || 0;

            const percent =
                summary.total
                    ? ((count / summary.total) * 100).toFixed(0)
                    : 0;

            const bar =
                row.querySelector(".trustshop-bar-container > div");

            if (bar) {

                bar.style.width = percent + "%";

            }

            const percentText =
                row.querySelector("div:last-child span");

            if (percentText) {

                percentText.textContent =
                    percent + "%";

            }

        });

        console.log("✅ Score Card Updated");

    }

    updateScoreCard();

})();